import { Slot } from './Slot';
import { ThemeColors } from '../Theme';

import { Global } from './Global'
import { Patron } from './Patron'

import { DateConversions } from '../utils/DateConversions';

export class Booking extends Slot {

    patron;     // Patron object, will always exist
    approved;    

    preBookingBlockId;
    postBookingBlockId;

    constructor(json, timezone) {
        super(json, timezone);
        this.preBookingBlockId = json ? json.preBookingBlockId : null;
        this.postBookingBlockId = json ? json.postBookingBlockId : null;
        this.patron = new Patron(json ? json.patron : null);
        this.approved = json ? json.approved : false;
    }

    static createNew(start, end, resource) {
        
        const booking = new Booking();
        booking.type = "Booking";
        booking.title = "Untitled Booking";
        
        // call superclass method        
        booking.newSlot("bk", start, end, [resource.id]);

        booking.color = resource.color ? resource.color : ThemeColors.appBarBackground;
        return booking;
    }

    copy() {
        const copy = new Booking();
        super.copy(copy);
        copy.patron = this.patron.copy();
        copy.approved = this.approved;
        copy.preBookingBlockId = this.preBookingBlockId;
        copy.postBookingBlockId = this.postBookingBlockId;
        return copy;
    }

    removeFieldsForNewSlot() {
        super.removeFieldsForNewSlot();
        this.patron = new Patron();     //empty patron
        this.approved = false;
        this.preBookingBlockId = null;
        this.postBookingBlockId = null;
    }

    canEdit(resources) {
        if (Global.isResourceManager())      // resource managers can always edit Bookings
            return true;
        
        const service = this.getService(resources);
        if (!service) {
            console.error("Booking " + this.id + " does not have a Service, which is not allowed");
            return false;
        }

        if (service.owner === Global.user.id) {        // owners of services can always edit their bookings (and there can only be one)
            return true;
        }
        
        return false;
    }

    refundable() {
        if (!this.patron)
            return false;
        return this.patron.refundable();
    }


    // Removes all assigned resources from the booking except the service
    removeAllAssignedResources = (resourcesList) => {
        const service = this.getService(resourcesList);
        if (service)
            this.resourceIds = [service.id];    // just keep the service
        else
            this.resourceIds = [];
    }


    inBookingByPatron() {
        if (this.state === "CREATED")
            return true;
        else if (this.state === "ACTIVE" && this.patron && this.patron.status() === Patron.Status.PAYMENT_PENDING)
            return true;
        return false;
    }


    status() {
        if (this.state === "CREATED" || !this.patron)       // no patron yet
            return "Awaiting Confirmation";

        else if (this.state === "ACTIVE") {                 // active booking, use patron status
            const patronStatus = this.patron.status();
            return patronStatus.displayName;
        }
        else 
            return super.status();      // some cancelled state, use superclass status
    }

    hasPatrons() {
        return this.patron && this.patron.patronEmail && super.hasPatrons();
    }

    
    details() {

        if (!this.patron)
            return "<div/>";  

        let details = this.patron.details();
        details += "<div style='margin-top: 5px'>Approved: " + (this.approved ? "✅" : "No") + "</div>"
        return details;
    }

    symbol() {
        if (this.state === "ACTIVE" && this.patron && this.patron.status() === Patron.Status.PAYMENT_PENDING)
            return "⁉️";        // awaiting payment
        
        if (this.state === "ACTIVE" && this.approved)
            return "✅"
        
        return super.symbol();
    }


    colorForStatus() {
        if (this.state === "ACTIVE" && this.patron && this.patron.status() === Patron.Status.PAYMENT_PENDING)
            return 'orange';
        return super.colorForStatus();
    }


    // Returns a 2-string array of the start date/time string and the duration string for the booking, formatted for display to the patron.  The duration string is empty for all day events
    patronStartAndDurationString() {
        const bookingDuration = this.duration() / 60;       // minutes
        let durationString;
        if (bookingDuration <= 90)
            durationString = "Duration: " +  bookingDuration + " mins";
        else if (this.isAllDay())   // one exact day
            durationString = "";
        else if (this.isMultiDay()) {       // exact number of days
            const days = bookingDuration / (60 * 24);
            durationString = "Duration: " +  days + " day" + (days > 1 ? "s" : "");
        }
        else {
            const hrs = Math.floor(bookingDuration / 60);
            const mins = bookingDuration % 60;
            durationString = "Duration: " + hrs + " hr" + (hrs > 1 ? "s" : "");
            if (mins > 0)
                durationString += ", " + mins + (mins > 1 ? " mins" : " min");
        }

        let startStr;
        if (this.isMultiDay())      // whole days, starting on midnight
            startStr = "Selected: " + DateConversions.dateStr(this.start);
        else
            startStr = "Selected: " + DateConversions.dateTimeStr(this.start);

        return [startStr, durationString];    
    }


}